// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.touch {
  position: fixed;
  right: 30px;
  bottom: 120px;
  opacity: 0.7;
  z-index: 5;
}
.touch .touch-tablet {
  width: 100px;
  height: 70px;
  border: 6px solid #fff;
  border-radius: 12px;
  position: absolute;
  bottom: 0;
  right: 0;
}
.touch .touch-circle {
  width: 30px;
  height: 30px;
  border: 5px solid #fff;
  border-radius: 40px;
  position: absolute;
  bottom: 30px;
  right: 35px;
  animation: touch-circle-anim 4s ease-out;
  animation-iteration-count: infinite;
}
.touch .touch-hand-icon {
  color: #fff;
  font-size: 40px;
  position: absolute;
  bottom: 5px;
  right: 28px;
  display: none;
  animation: touch-hand-anim 4s ease-out;
  animation-iteration-count: infinite;
}
.touch .touch-hand {
  width: 30px;
  position: absolute;
  bottom: 6px;
  right: 22px;
  animation: touch-handimg-anim 4s ease-out;
  animation-iteration-count: infinite;
}
.touch .touch-hand img {
  width: 100%;
  height: auto;
}

@keyframes touch-circle-anim {
  0% {
    transform: scale(0.1, 0.1);
    opacity: 0;
  }
  10% {
    transform: scale(0.1, 0.1);
    opacity: 0;
  }
  30% {
    opacity: 0.6;
  }
  40% {
    transform: scale(1.3, 1.3);
    opacity: 0;
  }
  100% {
    transform: scale(1.3, 1.3);
    opacity: 0;
  }
}
@keyframes touch-hand-anim {
  0% {
    transform: scale(1.5, 1.5);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  15% {
    transform: scale(1, 1);
    opacity: 1;
  }
  80% {
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}
@keyframes touch-handimg-anim {
  0% {
    transform: scale(1.5, 1.5);
    opacity: 0;
    padding-top: 10px;
    padding-left: 10px;
  }
  10% {
    opacity: 1;
    padding: 0;
  }
  15% {
    transform: scale(1, 1);
    opacity: 1;
  }
  80% {
    transform: scale(1, 1);
    opacity: 1;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
